import { useState, useEffect } from "react";
import { apiService, FollowRequest } from "../../api/apiService";

export const useInboundFollowRequests = () => {
  const [requests, setRequests] = useState<FollowRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchRequests = async () => {
    try {
      setLoading(true);
      const response = await apiService.followRequestsInbound();
      setRequests(response.data.requests);
      setError(null);
    } catch {
      setError("Failed to fetch follow requests");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  return {
    requests,
    loading,
    error,
    refetch: fetchRequests,
  };
};
